import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'navaar-more-vert-icon',
  template:`<svg xmlns="http://www.w3.org/2000/svg" width="4" height="17" viewBox="0 0 4 17">
  <g id="Group_3749" data-name="Group 3749" transform="translate(-24 -108)">
    <circle id="Ellipse_386" data-name="Ellipse 386" cx="2" cy="2" r="2" transform="translate(24 108)" fill="#fff"/>
    <circle id="Ellipse_387" data-name="Ellipse 387" cx="2" cy="2" r="2" transform="translate(24 115)" fill="#fff"/>
    <circle id="Ellipse_388" data-name="Ellipse 388" cx="2" cy="2" r="2" transform="translate(24 121)" fill="#fff"/>
  </g>
</svg>`
})
export class MoreVertIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
